// Supabase client configuration
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Hardcoded credentials for Lovable preview environment stability
const SUPABASE_URL = "https://glrjosqoeplclxbziyge.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdscmpvc3FvZXBsY2x4YnppeWdlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3NjcxNTEsImV4cCI6MjA4NTM0MzE1MX0.sZgLvaTflxMKWek98YgLXJVv198TXkafSw1LuhWiryg";

// Create Supabase client
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof window !== 'undefined' ? localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'X-Client-Info': 'cdrs-web',
    },
  },
});